export const CSRF: string =
	window.csrf ||
	window.Bynder?.csrf_token ||
	document.querySelector('meta[name="x-csrf-token"]')?.getAttribute('content') ||
	'';
